import React from 'react'
import {Hsn, Price, Total, AddInvoiceRow, Cgst, Igst, Sgst} from './rowelements/others'
import Series, {SeriesCounter} from './rowelements/series'
import NameElement from './rowelements/nameelement'
import ClientElement from './rowelements/clientelement'
import OutState, {AddCess} from './rowelements/outstate'
import InvoiceTotal  from './rowelements/invoicetotal'
import {CommonItemLevelTextInput} from '../commons/commoninput'
import SellingBasicRate from './rowelements/sellingbasicrate'
import SellingRate from './rowelements/sellingrate'
import InvoiceDate from './rowelements/invoicedate'
import QuantityElement from './rowelements/quantity'
import Discount from './rowelements/discount'
import CessPercentage from './rowelements/cess'
import {Loader} from '../../utils/misc'
import {Link } from 'react-router-dom'
import {getToken, getUserSettings, getUserProfile} from '../../storage'
import {NotificationManager} from 'react-notifications'
import {API_BASE_URL} from '../../constants'
import {CommonInvoiceLevelInput} from '../commons/commoninput'
import {basicRate,calculateSellingPrice, calculateSellingPrice2, calculateDiscount} from '../../utils/calculator'
import axios from 'axios'
import {ReceiptModal, TransportlabelModal, AdditionalParam} from '../modal/modal'


class ResponsiveRow extends React.Component {

  render() {

      let item = this.props.item
      let invoice = this.props.invoice


      return <div className="responsive-row">
        <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-3">
                <label className="hidden-md hidden-lg mtop">Name</label>
                <NameElement item={item} show_stock={false} onAddCallback={this.props.handleUpdateQuantity} />
              </div>

              <div className="col-xs-12 col-sm-6 col-md-3">
              <label className="hidden-md hidden-lg mtop">Description</label>
              <CommonItemLevelTextInput name="description" item={item} onChangeCallback={this.props.handleUpdateQuantity} />
              </div>

              <div className="col-xs-6 col-sm-2 col-md-1">
                <label className="hidden-md hidden-lg mtop">Quantity</label>
                <QuantityElement item={item} onChangeCallback={this.props.handleUpdateQuantity} />
              </div>


              <div className="col-xs-6 col-sm-2 col-md-1">
                <label className="hidden-md hidden-lg mtop">Rate</label>
                <SellingBasicRate item={item} onChangeCallback={this.props.handleUpdateBasicRate} />
              </div>




              <div className="col-xs-6 col-sm-4 col-md-1">
                <label className="hidden-md hidden-lg mtop">Total</label>
                <Total item={item} />
              </div>
              <div className="col-xs-6 col-sm-4 col-md-1 mtop">
                <button className="btn btn-danger btn-xs" onClick={(e)=>{this.props.deleteRow(item.tableIndex)} } >Delete</button>
              </div>

        </div>
      </div>



  }
}



class ResonsiveHeader extends React.Component {
  render() {
    let invoice = this.props.invoice



    return <div className="responsive-header hidden-xs hidden-sm"><div className="row">
          <div className="col-xs-12 col-sm-6 col-md-3">
            Name
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            Description
          </div>
          <div className="col-xs-6 col-sm-2 col-md-1">
            Quantity
          </div>
          <div className="col-xs-6 col-sm-2 col-md-1">
            Rate
          </div>

          <div className="col-xs-4 col-sm-4 col-md-1">
            Total
          </div>
          <div className="col-xs-6 col-sm-4 col-md-1">
          </div>
    </div></div>

  }
}

export default class Invoice extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      loading:true,
      showReceipts:false,
      showTransportlabel:false,
      invoice: {
        is_igst:false,
        is_batch:false,
        totalPrice:0,
        totalTax:0,
        totalCess:0,
        totalDiscount:0,
        total:0
      }
    }
    this.handleClientChange = this.handleClientChange.bind(this)
    this.handleDateChange= this.handleDateChange.bind(this)
    this.handleOutStateChange = this.handleOutStateChange.bind(this)
    this.handleAddCessChage = this.handleAddCessChage.bind(this)
    this.handleUpdateItem = this.handleUpdateItem.bind(this)
    this.modifyItemState = this.modifyItemState.bind(this)
    this.handleAddItem = this.handleAddItem.bind(this)
    this.handleAddItemWithDiscount = this.handleAddItemWithDiscount.bind(this)
    this.handleDeleteItem = this.handleDeleteItem.bind(this)
    this.handleAddRow = this.handleAddRow.bind(this)
    this.handleCalculateTotal = this.handleCalculateTotal.bind(this)
    this.handleUpdateQuantity = this.handleUpdateQuantity.bind(this)
    this.handleUpdateBasicRate = this.handleUpdateBasicRate.bind(this)
    this.handleUpdateSellingPrice = this.handleUpdateSellingPrice.bind(this)
    this.getDiscount = this.getDiscount.bind(this)
    this.deleteInvoice = this.deleteInvoice.bind(this)
    this.handleShowReceipts = this.handleShowReceipts.bind(this)
    this.handleShowTransportlabel = this.handleShowTransportlabel.bind(this)
    this.handleAddTransportlabel = this.handleAddTransportlabel.bind(this)
    this.handleRemoveTransportlabel = this.handleRemoveTransportlabel.bind(this)
    this.handleSeriesChange = this.handleSeriesChange.bind(this)
    this.submit = this.submit.bind(this)
    this.addParam = this.addParam.bind(this)
    this.removeParam = this.removeParam.bind(this)
  }

  handleParamChange = ( k,v) => {

    let currentItem = this.state.invoice
    let existingParams = this.state.invoice.additional_params
    if(typeof existingParams !== "undefined" && existingParams !== null) {
        existingParams = existingParams.filter(param => {
          return param.key !==k
        })
    }
    else {
      existingParams = []
    }

    existingParams.push({key:k, value:v})

    currentItem['additional_params'] = existingParams
    this.setState({invoice:currentItem})

  }


  addParam( k,v) {
    let currentItem = this.state.invoice
    let existingParams = this.state.invoice.additional_params
    if(typeof existingParams !== "undefined" && existingParams !== null) {
        existingParams.push({key:k, value:v})
    }
    else {
      existingParams = []
      existingParams.push({key:k, value:v})
    }

    currentItem['additional_params'] = existingParams
    this.setState({invoice:currentItem})

  }

  removeParam(k) {
    let currentItem = this.state.invoice
    let existingParams = this.state.invoice.additional_params
    existingParams = existingParams.filter(param => param.key!==k)
    currentItem['additional_params'] = existingParams
    this.setState({invoice:currentItem})
  }

  handleSeriesChange(series_name) {
    this.modifyItemState('series_name', series_name)
  }

  handleUpdateBasicRate(item) {
    // calculate selling price
    var b = item['selling_basic_rate']
    item['selling_rate'] = b
    this.handleUpdateQuantity(item)
  }

  handleAddTransportlabel(transportlabel) {
    this.modifyItemState('transportlabel',transportlabel)
    this.handleShowTransportlabel()
  }
  handleRemoveTransportlabel() {
    this.modifyItemState('transportlabel', null)
  }


  handleUpdateSellingPrice(item) {
    // calculate basic rate
    var s = item['selling_rate']
    if (isNaN(s)) {
      s = 0
    }
    else {

      if(typeof item.gst !== "undefined" && item.gst !== null) {

          let gst_pct = 0
          if(item.gst.type === "C") {
            gst_pct = parseFloat(item.gst.cgst) + parseFloat(item.gst.sgst)
          }
          else {
            gst_pct = parseFloat(item.gst.igst)
          }
          item['selling_basic_rate'] = basicRate(s, gst_pct)
          this.handleUpdateQuantity(item)
      }
    }
  }

  componentDidMount() {

    let params = this.props.match.params
    if(typeof params.invoice_id !== "undefined") {
      this.setState({mode:'edit'})
      document.title = "Edit Invoice " + this.props.match.params.invoice_id
      this.getInvoice(this.props.match.params.invoice_id).then((response)=>{
        if(response.status===200) {
          this.setState({invoice: response.data.invoice, loading:false, invoice_item_tableindex: response.data.invoice.saleitem_set.length})

        }
      }).catch((err)=>{
        this.setState({loading:false})
      })
    }
    else {
        document.title = "Create Invoice "
        this.setState({loading:false})
        this.handleAddRow()
    }
    this.getSettings().then((res)=>{
      if(res.status === 200) {
        this.setState({settings:res.data.settings})
      }
    })
  }

  getSettings() {
    return axios({
      url: '/get_settings/',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  getInvoice(invoice_id) {
    return axios({
      url: '/get_invoice/?serial='+invoice_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  getDiscount(item) {

    // calculate discount
    let quantity = parseFloat(item.quantity)
    if(quantity <= 0) {
      item['discount_value'] = 0
    }
    else if( typeof item['discount_edited'] !== "undefined" ) {
      item['discount_value'] = parseFloat(item['discount_edited'])
    }
    else {
      let discounts = item.discounts
      let matchingDiscount
      if(typeof discounts !== "undefined" && discounts !== null) {

        // sort discount set with respect to quantity
        discounts = discounts.sort((a,b)=>{
          return b.quantity - a.quantity
        })

        for(var i=0; i<discounts.length; i++) {
          let d = discounts[i]
          if(quantity >= d.quantity) {
            matchingDiscount = d
            break;
          }
        }

        if(typeof matchingDiscount !== "undefined") {
            // if discount defined in percentage
            if(matchingDiscount.is_percentage) {
              item['discount_value'] = calculateDiscount(item.price, matchingDiscount.rate)
            }
            else {
              item['discount_value'] = matchingDiscount.value
            }
        }
        else {
              item['discount_value'] = 0
        }

    }
    else {
      item['discount_value'] = 0
    }
  }
}

handleUpdateQuantity(item) {

  // calculate price, cgst, sgst, igst, total
  let gst = item.gst

  var b = parseFloat(item.selling_basic_rate), q = parseFloat(item.quantity)
  if (isNaN(b)) {
    b = 0
  }

  if (isNaN(q)) {
    q = Number(0)
  }

  item['price']  = parseFloat(parseFloat(b * q).toFixed(2))
  this.getDiscount(item)
  let afterDiscount = item['price']
  if(!isNaN(item['discount_value'])) {
      afterDiscount = item['price'] - parseFloat(item['discount_value'])
  }
  else {
    // not a number
    item['discount_value'] = Number(0)
  }

  item['price'] = parseFloat(afterDiscount).toFixed(2)
  if(afterDiscount <=0) {
    afterDiscount = 0
  }
  if(typeof gst !== "undefined" && gst !== null && gst.type !== "undefined" && gst.type !== null) {
      item['cgst_amount'] = parseFloat( parseFloat(afterDiscount*gst.cgst/100).toFixed(2) )
      item['sgst_amount'] = parseFloat( parseFloat(afterDiscount*gst.sgst/100).toFixed(2) )
      item['igst_amount'] = parseFloat( parseFloat(afterDiscount*gst.igst/100).toFixed(2) )
  }
  else {
    item['cgst_amount'] = parseFloat(item['cgst_amount'])
    item['sgst_amount'] = parseFloat(item['sgst_amount'])
    item['igst_amount'] = parseFloat(item['igst_amount'])
  }


  item['total'] = parseFloat(parseFloat(afterDiscount + item['igst_amount']).toFixed(2))

  this.handleUpdateItem(item)
}

  handleCalculateTotal(invoice_saleitem_set) {

    let total = 0, totalPrice=0, totalCess=0, totalTax=0, totalDiscount=0
      if(typeof invoice_saleitem_set !== "undefined") {
        invoice_saleitem_set.forEach((item,i)=> {
          totalPrice = totalPrice + parseFloat(parseFloat(item.price).toFixed(2))
          totalDiscount = totalDiscount + parseFloat(parseFloat(item.discount_value).toFixed(2))


          if(item.cess_amount) {
              totalCess = totalCess + parseFloat(parseFloat(item.cess_amount).toFixed(2))
          }
          if(item.specific_cess_amount) {
            totalCess = totalCess + parseFloat(parseFloat(item.specific_cess_amount).toFixed(2))
          }


          totalTax = totalTax + parseFloat(parseFloat(item.igst_amount).toFixed(2))
          total = total + parseFloat(parseFloat(item.total).toFixed(2))
        })
      }

      totalPrice = parseFloat(totalPrice).toFixed(2)
      totalDiscount = parseFloat(totalDiscount).toFixed(2)
      totalCess = parseFloat(totalCess).toFixed(2)
      totalTax = parseFloat(totalTax).toFixed(2)
      total = parseFloat(Math.round(parseFloat(total).toFixed(2))).toFixed(2)
      this.modifyItemState('totalPrice', totalPrice)
      this.modifyItemState('totalDiscount', totalDiscount)
      this.modifyItemState('totalCess', totalCess)
      this.modifyItemState('totalTax', totalTax)
      this.modifyItemState('total', total)
  }

  handleAddItemWithDiscount(item) {
    this.getDiscount(item)
    this.handleUpdateItem(item)
  }

  handleUpdateItem(item) {
    if(typeof item.discount_value === "undefined") {
      item['discount_value'] = ""
    }

    let invoice = this.state.invoice
    let invoice_saleitem_set = []
    if(typeof invoice.saleitem_set !== "undefined") {
        invoice_saleitem_set = invoice.saleitem_set.filter(obj=> obj.tableIndex !== item.tableIndex)
    }

    invoice_saleitem_set = invoice_saleitem_set.concat(item)
    this.modifyItemState('saleitem_set', invoice_saleitem_set)
    this.handleCalculateTotal(invoice_saleitem_set)
  }

  handleDeleteItem(item_index){
    let invoice = this.state.invoice
    let invoice_saleitem_set = []
    if(typeof invoice.saleitem_set !== "undefined") {
        invoice_saleitem_set = invoice.saleitem_set.filter((item,i)=> item.tableIndex !== item_index)

        const reIndexed = invoice_saleitem_set.map((item,i)=>{
            item['tableIndex'] = i+1
            return item
        })

        this.modifyItemState('saleitem_set', reIndexed)
        this.setState({invoice_item_tableindex: invoice_saleitem_set.length})
        this.handleCalculateTotal(invoice_saleitem_set)
    }

  }

  handleAddItem(item) {
    console.log("adding item", item);
    this.handleUpdateItem(item)
    // let invoice = this.state.invoice
    // let invoice_saleitem_set = []
    // if(typeof invoice.saleitem_set !== "undefined") {
    //     invoice_saleitem_set= invoice.saleitem_set
    // }
    //
    // invoice_saleitem_set.push(item)
    // this.modifyItemState('saleitem_set', invoice_saleitem_set)
  }

  modifyItemState(key, value) {
        let currentInvoice = this.state.invoice
        currentInvoice[key] = value
        this.setState({
          invoice:currentInvoice
       });
  }


  handleClientChange(client) {
    this.modifyItemState('client', client)
    let profile = getUserProfile()
    if(profile.tax_type === "G") {
      let gstin = profile.gstin
      if(client) {
        let client_gstin = client.gstin
        if(gstin && client_gstin) {
            if(gstin.substring(0,2) !== client_gstin.substring(0,2)) {
              this.modifyItemState('is_igst', true)
            }
            else {
              this.modifyItemState('is_igst', false)
            }
        }
      }
      else {
        this.modifyItemState('is_igst', false)
      }

    }
  }

  handleOutStateChange(outstate) {
    this.modifyItemState('is_igst', outstate)
  }
  handleAddCessChage(add_cess){
    this.modifyItemState('add_cess', add_cess)
  }
  handleDateChange(date){
    this.modifyItemState('date', date)
  }
  handleShowReceipts() {
    this.setState({showReceipts: !this.state.showReceipts})
  }
  handleShowTransportlabel() {
    this.setState({showTransportlabel: !this.state.showTransportlabel})
  }

  handleAddRow(event) {

    let tableIndex
    if(typeof this.state.invoice_item_tableindex !== "undefined") {
      tableIndex = this.state.invoice_item_tableindex + 1
    }
    else {
      tableIndex = 1
    }
    const emptyData = {hsn:"", quantity:0, mrp:0, gst:{}, serial:0, cess_percentage:0, cess_amount:0, specific_cess_amount:0,
      discount_value:0, selling_basic_rate:0, basic_purchase_rate:0, selling_rate:0, price:0, tax:0, total:0, tableIndex:tableIndex,
      cgst_amount:0, sgst_amount:0, igst_amount:0, discounts:[]}
    if(typeof event !== "undefined") {
        emptyData['namefocus'] = true
    }
    this.handleAddItem(emptyData)

    this.setState({invoice_item_tableindex:tableIndex})

  }

  deleteInvoice() {

    let confirmation = window.confirm('You are about to delete this invoice !')

    if(confirmation) {
      axios({
        url: '/delete_invoice/',
        method: 'post',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          },
          post: {
            'Content-Type': 'multipart/form-data;'
          }
        },
        data: this.state.invoice
      }).then((response)=> {
        if(response.status === 200) {
            NotificationManager.success("Deleted invoice successfully")
          setTimeout(()=>{
            this.props.history.push("/invoices/")
          }, 700)
        }
      }).catch((err)=> {
        console.log(err);
      })
    }

  }

  submit(e) {

    this.setState({'submitting':true})

    let action = e.target.name;

    let apiurl
    if(this.state.mode ==="edit") {
      apiurl  = "/update_invoice/"
    }
    else {
      apiurl  = "/create_new_invoice/"
    }
    axios({
      url: apiurl,
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.invoice
    }).then((response)=> {
      this.setState({'submitting':false})
      if(response.status === 200) {
         let respondedInvoice = response.data.invoice
        if(this.state.mode === "edit") {
            NotificationManager.success("Updated invoice successfully")
        }
        else {
          NotificationManager.success("Created invoice successfully")
        }

        if(action === "saveprint") {
          this.props.history.push("/invoices/preview/"+respondedInvoice.serial+"/?print=true")
        }
        else {
          setTimeout(()=>{

            this.props.history.push("/invoices/")
          }, 700)
        }


      }
    }).catch((err)=> {
      this.setState({'submitting':false})
      if(typeof err.response !== "undefined" && typeof err.response.data !== "undefined") {
        let error_response_data = err.response.data.error
        if(typeof error_response_data !== "undefined") {
          NotificationManager.error(error_response_data)
        }
      }

    })
  }



  render() {
      let settings = getUserSettings()
      let invoice = this.state.invoice
      let submitButton = <input type="submit" name="save" className="btn btn-success" value="save" onClick={this.submit} />
      let saveAndPrintButton = <input type="submit" name="saveprint" className="btn btn-success" value="Save & Preview" onClick={this.submit} />
      if(this.state.submitting) {
        submitButton = <input type="submit" className="btn btn-success" value="saving.." disabled />
        saveAndPrintButton = <input type="submit" className="btn btn-success" value="Saving.." disabled />
      }

      let client = <ClientElement invoice={invoice} onAddCallback={this.handleClientChange} />

      let rowELements = []
      if(typeof invoice.saleitem_set !== "undefined") {

        invoice.saleitem_set.sort((a,b)=>{
          return a.tableIndex - b.tableIndex
        })

        rowELements = invoice.saleitem_set.map((item, i)=>{
          i++
          return <ResponsiveRow invoice={invoice} item={item} rowno={i} key={i} deleteRow={this.handleDeleteItem}
          handleUpdateItem={this.handleAddItemWithDiscount}
          handleUpdateQuantity = {this.handleUpdateQuantity}
          handleUpdateBasicRate = {this.handleUpdateBasicRate}
          handleUpdateSellingPrice = {this.handleUpdateSellingPrice} />
        })
      }

      let pageHeader
      let deleteInvoiceBtn

      let receiptsLink, receiptModal, previewLink, transportlabelModal, transportlabelLink
      let series_option, series_counter
      if(!this.state.loading) {

        if(this.state.mode === "edit") {
          pageHeader = <h3>{"Edit Invoice  #" + invoice.series_name + " " + invoice.series_counter}</h3>
          deleteInvoiceBtn = <button className="btn btn-sm btn-danger" onClick={this.deleteInvoice}>Delete Invoice</button>
          receiptsLink = <Link to="#" className="btn btn-primary" onClick={this.handleShowReceipts}>Receipts</Link>
          previewLink = <Link to={"/invoices/preview/"+this.props.match.params.invoice_id} className="btn btn-primary" > Preview</Link>
          receiptModal = <ReceiptModal show={this.state.showReceipts} handleClose={this.handleShowReceipts} invoice={invoice.id} />
          series_option = {series_name: invoice.series_name}
          series_counter = invoice.series_counter
        }
        else {
          pageHeader =  <h3>Create New Invoice</h3>
          series_option = {series_name: invoice.series_name}
        }



        let series = <div>
                      <Series option={series_option} onChangeCallback={this.handleSeriesChange} />
          </div>


          let additionalParams, totalBlock, purchase_order, invoice_additional_params
          if(typeof settings !== "undefined") {

              if(settings.enable_invoice_additional_params) {
                  additionalParams = <AdditionalParam additional_params={invoice.additional_params} addParam={this.addParam} removeParam={this.removeParam} />
              }
              let settingOptions = settings.options


              if(settingOptions) {




                if(settingOptions.invoice_additional_params && settingOptions.invoice_additional_params.length)  {
                  invoice_additional_params = settingOptions.invoice_additional_params.map((param, id)=>{

                    let defaultValue
                    if(invoice.additional_params) {
                       invoice.additional_params.forEach((p)=>{
                        if(p.key == param) {
                          defaultValue = p.value
                        }
                      })
                    }

                    return <div className="form-group" key={id}>
                          <label className="col-sm-3">
                            {param}
                          </label>
                          <div className="col-sm-9">
                              <input ref={param} type="text" defaultValue={defaultValue} className="form-control input-sm" onChange={(e)=>{
                                  e.preventDefault();
                                  this.handleParamChange(param, this.refs[param].value)
                                }} />
                          </div>
                    </div>
                  })
                }
              }


          }

        totalBlock = <InvoiceTotal invoice={invoice} />



        return <div className="container-fluid">
            {receiptModal}
        <section className="medium">
              {pageHeader}
              <ul className="list-inline">
                <li>{receiptsLink}</li>
                <li>{previewLink}</li>
                <li className="pull-right">{deleteInvoiceBtn}</li>
              </ul>
        </section>
            <section className="small">
              <div className="row">
                <div className="col-sm-3">
                  <h4>Client</h4>
                  {client}
                </div>
                <div className="col-sm-2">
                  <h4>Date</h4>
                  <InvoiceDate invoice={invoice} handleDateChange={this.handleDateChange} />
                </div>


                <div className="col-sm-2">
                <h4>Series</h4>
                {series}
                </div>
                <div className="col-sm-1">
                <h4>Serial</h4>
                <SeriesCounter modifyItemState={this.modifyItemState} series_counter={series_counter} />
                </div>

              </div>
              <div className="row">
                {purchase_order}
              </div>
            </section>
            <section className="small">
              <div className="row">
                <div className="col-sm-12">
                  <div className="">
                      <ResonsiveHeader invoice={invoice} />
                      {rowELements}

                      <div className="panel-body">
                      <AddInvoiceRow handleAddRow={this.handleAddRow}  />
                      </div>

                      <section className="medium">
                        <div className="row">
                        <div className="col-xs-6  col-sm-6">
                        {additionalParams}
                        {invoice_additional_params}
                        </div>
                            <div className="col-xs-6  col-sm-3 col-sm-offset-3">
                            {totalBlock}
                            </div>
                        </div>
                      </section>


                  </div>

                  <div className="text-right">

                    <ul className="list-inline">
                        <li>{submitButton}</li>
                        <li>{saveAndPrintButton}</li>
                    </ul>

                  </div>
                </div>
              </div>
            </section>
          </div>

      }
      else {
        return <div>
            <Loader />
        </div>
      }



  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/invoicesimpleservice.js